document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('[data-hover-images]');

  cards.forEach(function (card) {
    const image = card.querySelector('.product-card-secondary-image');

    if (!image) return;

    let images = [];

    try {
      images = JSON.parse(card.dataset.hoverImages);
    } catch (error) {
      return;
    }

    if (!images || images.length < 2) return;

    let currentIndex = 0;
    let interval = null;

    function showImage() {
      image.src = images[currentIndex];
      image.srcset = images[currentIndex];
    }

    function showNextImage() {
      currentIndex++;

      if (currentIndex >= images.length) {
        currentIndex = 0;
      }

      showImage();
    }

    function startSlideshow() {
      if (interval) return;

      // Commence par la première photo
      currentIndex = 0;
      showImage();

      // Puis passe aux suivantes
      interval = setInterval(showNextImage, 1500);
    }

    function stopSlideshow() {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }

      // On remet la deuxième photo dans l'image secondaire.
      // Quand le survol disparaît, Shopify réaffiche naturellement la première.
      currentIndex = 1;
      showImage();
    }

    card.addEventListener('mouseenter', startSlideshow);
    card.addEventListener('mouseleave', stopSlideshow);
  });
});